import { jsx as _jsx } from "react/jsx-runtime";
import { Calculator, CalendarRange } from 'lucide-react';
import { createModulePerms } from '@wit-support/ui-domain';
import { AccountingQuartersPage } from './routes/quarters.js';
import { AccountingQuarterPage } from './routes/quarter.js';
import { AccountingRegionPage } from './routes/region.js';
// Fail-closed: модуль вне провайдера шелла показывает раздел только для чтения.
const { Provider: AccountingModulePermsProvider, usePerms: useAccountingPerms } = createModulePerms({ canManage: false });
export { AccountingModulePermsProvider, useAccountingPerms };
function QuartersRoute() {
    const { canManage } = useAccountingPerms();
    return _jsx(AccountingQuartersPage, { canManage: canManage });
}
function QuarterRoute() {
    const { canManage } = useAccountingPerms();
    return _jsx(AccountingQuarterPage, { canManage: canManage });
}
/**
 * Раздел «Бухгалтерия» — квартальный НДС (ЕС OSS, Великобритания) через шлюз
 * admin-api `/api/accounting/*` к платёжному сервису. Считает платёжка;
 * модуль только показывает отчёты, запускает пересчёт и ставит отметку «подан».
 *
 * Модуль отсоединяемый: импортирует только кит (`ui`, `ui-domain`,
 * `ui-forms`), `admin-client-core` и `admin-contracts` (ESLint allowlist).
 */
export const accountingModule = {
    id: 'accounting',
    label: 'Бухгалтерия',
    icon: Calculator,
    permission: 'accounting.read',
    workspace: 'accounting',
    order: 10,
    description: 'Квартальный НДС: сколько ввести в ROS и мост по каждому региону, отметка о подаче.',
    showInNav: true,
    sectionsPlacement: 'sidebar',
    sections: [{ path: '/', label: 'Кварталы', icon: CalendarRange }],
    // Страница квартала и региона своих пунктов не имеют и подсвечивают «Кварталы».
    routes: [
        { path: '/', component: QuartersRoute },
        { path: '/$quarter', component: QuarterRoute, label: 'Квартал' },
        { path: '/$quarter/$region', component: AccountingRegionPage, label: 'Регион' },
    ],
};
export { AccountingQuartersPage } from './routes/quarters.js';
export { AccountingQuarterPage } from './routes/quarter.js';
export { AccountingRegionPage } from './routes/region.js';
export { setAccountingApiBaseUrl, AccountingRequestError } from './api.js';
//# sourceMappingURL=index.js.map